import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

export const exportBoostAdPdf = async (element: HTMLElement, title: string): Promise<void> => {
  const canvas = await html2canvas(element, {
    useCORS: true,
    allowTaint: false,
    backgroundColor: '#ffffff',
    scale: 2,
  });

  const dataUrl = canvas.toDataURL('image/png');

  const pdfWidth = 210;
  const margin = 15;
  const contentWidth = pdfWidth - margin * 2;
  const contentHeight = (canvas.height / canvas.width) * contentWidth;

  const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });

  pdf.setFontSize(14);
  pdf.text(title, margin, margin + 5);
  pdf.addImage(dataUrl, 'PNG', margin, margin + 12, contentWidth, contentHeight);

  const safeFilename = title.replace(/[^a-zA-Z0-9_-]/g, '_');
  pdf.save(`${safeFilename}_ad_preview.pdf`);
};
